import { gql } from '@apollo/client';

export const CREATE_USER = gql`
	mutation CreateUser($user: CreateUserDto!) {
		createUser(user: $user) {
			user_id
			email
			first_name
			last_name
		}
	}
`;

// register(user: RegisterUser!): Success!
export const REGISTER_USER = gql`
	mutation RegisterUser($user: RegisterUser!) {
		register(user: $user) {
			success
		}
	}
`;
